<template>
  <div
    class="global-filial-select"
    :title="globalFilialShortName"
    @click.capture="measureMenu"
  >
    <v-select
      ref="select"
      :value="globalFilialId"
      :items="filteredFilials"
      item-text="name"
      item-value="id"
      label="Филиал"
      hide-details="auto"
      class=""
      background-color="#F1F3F6"
      height="60"
      flat
      solo
      :loading="loadingList"
      :disabled="loadingList"
      :menu-props="menuProps"
      no-data-text="Ничего не найдено"
      return-object
      @change="setGlobalFilial"
    >
      <template v-slot:prepend-item>
        <v-list-item class="search-global-filial">
          <v-list-item-content>
            <v-text-field
              v-model="search"
              placeholder="Поиск..."
              filled
              dense
            >
              <template v-slot:append>
                <font-awesome-icon color="#FF9100" icon="search" />
              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{item}">
        <global-filial-select-item
          :item="item"
          :is-select-value="true"
        />
      </template>

      <template v-slot:item="{item, attrs}">
        <global-filial-select-item
          :item="item"
          :selected="attrs['aria-selected'] === 'true'" :width="'100%'"
          :is-list-item="true"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GlobalFilialSelectItem from '@/components/header/GlobalFilialSelectItem'

  /** Ввод `...` в поиске - показать только филиалы, подключённые к FACT */
  const CONNECTED_ONLY_PREFIX = '...'

  /** Список не уже этого, даже когда выбор свёрнут в кнопку с иконкой */
  const MENU_MIN_WIDTH = 300
  /** Зазор между низом списка и краем экрана */
  const MENU_BOTTOM_GAP = 24
  /** VSelect рендерит список порциями и докидывает их при прокрутке */
  const ITEMS_CHUNK = 20
  /** Сколько ждать появления списка на экране, мс */
  const REVEAL_TIMEOUT = 1000

  export default {
    name: 'GlobalFilialSelect',
    components: { GlobalFilialSelectItem },
    data () {
      return {
        search: '',
        menuMaxHeight: 400,
        menuMinWidth: MENU_MIN_WIDTH,
      }
    },
    async created () {
      /* if (!this.allFilials || !this.allFilials.length) {
        console.log('start loadFilialsData')
        await this.loadFilialsData()
        console.log('end loadFilialsData')
      } */

    },
    computed: {
      ...mapGetters({
        loadingList: 'branches/getLoadingListState',
        allFilials: 'branches/getBranches',
        globalFilialId: 'branches/getGlobalFilialId',
        globalFilialShortName: 'branches/getGlobalFilialShortName',
      }),
      /**
       * Поиск по имени. Префикс `...` оставляет только филиалы, подключённые к FACT
       * (isConnected === true); остаток строки после префикса ищется по имени.
       */
      filteredFilials () {
        const query = this.search.trim()
        const connectedOnly = query.startsWith(CONNECTED_ONLY_PREFIX)
        const nameQuery = (connectedOnly ? query.slice(CONNECTED_ONLY_PREFIX.length) : query).trim().toLowerCase()

        return this.allFilials.filter((filial) => {
          if (connectedOnly && filial.isConnected !== true) return false
          return filial.name.toLowerCase().includes(nameQuery)
        })
      },
      // offsetY: список открывается под блоком выбора, а не поверх него.
      // Высота - не больше остатка экрана под блоком: иначе Vuetify, не уместив
      // список, сдвигает его вверх и снова накрывает блок
      menuProps () {
        return {
          contentClass: 'global-filial-select-menu',
          offsetY: true,
          maxHeight: this.menuMaxHeight,
          minWidth: this.menuMinWidth,
        }
      },
      selectedFilial: {
        get () {
          return ''
        },
        set (value) {
          if (value.id !== this.selectedBranch.id) {
            this.$store.commit('branches/setCurrentBranch', value)
            window.location.reload()
          }
        },
      },
    },
    mounted () {
      // у v-select нет события открытия списка - следим за его состоянием
      this.$watch(
        () => this.$refs.select.isMenuActive,
        (isActive) => {
          if (isActive) {
            this.revealSelectedFilial()
          } else {
            // иначе при следующем открытии выбранного филиала может не быть в списке
            this.search = ''
          }
        },
      )
    },
    methods: {
      // Замер до открытия: клик ловим на capture, раньше обработчика v-select
      measureMenu () {
        const rect = this.$el.getBoundingClientRect()
        this.menuMaxHeight = Math.max(200, window.innerHeight - rect.bottom - MENU_BOTTOM_GAP)
        this.menuMinWidth = Math.max(rect.width, MENU_MIN_WIDTH)
      },
      revealSelectedFilial () {
        const select = this.$refs.select
        const index = this.filteredFilials.findIndex((filial) => filial.id === this.globalFilialId)
        if (index < 0) return

        // выбранный филиал может лежать за первой порцией и ещё не быть в DOM
        if (select.lastItem <= index) {
          select.lastItem = index + ITEMS_CHUNK
        }

        // Контент меню создаётся лениво и сначала скрыт, а прокрутка скрытого
        // блока не срабатывает - ждём по кадрам, пока список появится на экране
        const startedAt = Date.now()
        const scrollToSelected = () => {
          if (!select.isMenuActive || Date.now() - startedAt > REVEAL_TIMEOUT) return

          const content = select.$refs.menu && select.$refs.menu.$refs.content
          const tile = content && content.querySelectorAll('.v-list-item:not(.search-global-filial)')[index]
          if (!tile || !content.clientHeight) {
            requestAnimationFrame(scrollToSelected)
            return
          }

          let top = 0
          for (let el = tile; el && el !== content; el = el.offsetParent) {
            top += el.offsetTop
          }
          content.scrollTop = top - (content.clientHeight - tile.offsetHeight) / 2
        }
        requestAnimationFrame(scrollToSelected)
      },
      async loadFilialsData () {
        await this.$store.dispatch('branches/fetchBranches')
      },
      setGlobalFilial (filial) {
        this.$store.commit('branches/setCurrentBranch', filial)
        window.location.reload()
      },
    },

  }
</script>

<style lang="less">

.global-filial-select {

  &__icon {
    margin-right: 7px;
  }

  .v-select__selections {
    font-size: 14px;
  }

  // Уже 1100px выбор филиала свёрнут в кнопку с иконкой,
  // название - в подсказке и в самом списке
  .media-compact-pc-narrow({
    width: 60px;

    .v-input__slot {
      padding: 0 !important;
      cursor: pointer;
    }

    .v-select__selections {
      justify-content: center;

      // поле остаётся в DOM - на нём фокус и клавиатура
      input {
        position: absolute;
        width: 0;
        min-width: 0;
        padding: 0;
      }
    }

    .s-filial-item__icon {
      margin-right: 0;
    }

    .s-filial-item__content,
    .v-input__append-inner,
    .v-label {
      display: none;
    }
  });

}

.global-filial-select-menu {
   box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.search-global-filial {
  margin-top: -8px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  //border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  .v-text-field {
    & > .v-input__control {
      & > .v-input__slot {
        &:after,
        &:before {
          display: none;
        }
      }
    }
  }
  .v-input {
    border-radius: 5px;
    input {
      font-size: 14px;
    }

    &.v-text-field--outlined.v-input--is-focused fieldset {
       border: 1px solid rgba(0,0,0, 0.7) !important;
    }

    &__append-inner {
      margin: auto 0 !important;
    }
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
